import Cart from '../../../api/cart';
import { track } from '../../../analytics/shared';
import { addLoadingState } from '../../loading-state-helpers';
import SessionStorage from '../../../utils/session-storage';

import { PRODUCTS_DATA_KEY } from '../../../utils/session-storage-keys';
import { ONE_CLICK_CHECKOUT_BUTTON } from '../../../classnames/design-system';

export default class OneClickCheckoutHandler {
  constructor(selector) {
    this.selector = selector;
    this.cartApi = new Cart();
  }

  getToCheckout = async ({ target }) => {
    try {
      // 1) Show loading state as soon as user clicks
      addLoadingState(target);

      // 2) Clear the cart so we start fresh
      await fetch('/cart/clear.js', { method: 'POST' });

      // 3) Build request params
      const params = this.buildRequestParams(target);
      const subscriptionId = params.subscriptionId || '';
      const customCartAttributeKey = target.dataset.cartAttributeKey || '';
      const customCartAttributeValue = target.dataset.cartAttributeValue || '';

      // 4) Add item to cart using the same flow as the main Cart
      await this.cartApi.addCartItem({
        quantity: params.quantity,
        variantId: params.variantId,
        isSubscription: params.isSubscription
      });

      // 5) Update custom attributes via /cart/update.js
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            ...(subscriptionId && { subscriptionId }),
            ...(customCartAttributeKey && { [customCartAttributeKey]: customCartAttributeValue }),
            path: window.location.pathname
          }
        })
      })
        .then((response) => response.json())
        .then(() => {
          // eslint-disable-next-line no-console
          console.log('Cart updated with custom attributes.');
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Error:', error);
        });

      // 6) Track analytics
      const productsData = {
        variantId: params.variantId,
        quantity: params.quantity,
        subscriptionId: params.subscriptionId,
        purchase_type: params.isSubscription ? 'subscription' : 'one-time',
        uniqToken: window?.ShopifyAnalytics?.lib?.trekkie?.defaultAttributes?.uniqToken
      };

      track({
        eventName: 'checkout_initiated',
        data: {
          line_item_properties: productsData
        }
      });

      SessionStorage.set(PRODUCTS_DATA_KEY, [productsData]);

      // 7) Redirect user straight to checkout
      window.location.href = '/checkout';
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Quick checkout error:', error);
    }
  };

  buildRequestParams = ({ dataset: { variantId, localSubscriptionState, subscriptionId }}) => ({
    variantId,
    subscriptionId,
    quantity: this.selector.getQuantity(),
    isSubscription: this.selector.isSubscription(localSubscriptionState)
  });

  initializeEventListeners = () => {
    const buttons = document.getElementsByClassName(ONE_CLICK_CHECKOUT_BUTTON);
    if (buttons.length === 0) return;

    [...buttons].forEach((button) => {
      button.addEventListener('click', this.getToCheckout);
    });
  };
}
